export const randomInteger = (max: number) => Math.floor(Math.random() * max);
